// extracted by mini-css-extract-plugin
export default {"filterName":"Filter_filterName__Y2kKA","filterLabel":"Filter_filterLabel__+pnW-"};